/* eslint-disable react/jsx-handler-names */
/* eslint-disable no-useless-constructor */
import React, { Component } from "react";
import { connect } from "react-redux";
import cx from "classnames";
import queryString from "query-string";
import isEmail from "validator/lib/isEmail";
import { get } from "lodash";
import {
  MDBRow,
  MDBCol,
  MDBCard,
  MDBCardBody,
  MDBCardHeader,
  MDBAlert
} from "mdbreact";
import {
  getAllPaymentMethod,
  selectedPaymentMethod,
  resetPaymentMethod
} from "~/store/payment/paymentAction";
import { createDepositApp } from "~/store/appDepositPayment/actions";
import MetaTags from "react-meta-tags";
import ListPaymentMethod from "~/components/desktop/molecules/ListPaymentMethod";
import Modal from "~/components/common/molecules/Modal";
import Alert from "~/components/common/atoms/Alert";
import PKHBtn from "~/components/common/atoms/Button";
import styles from "./style.module.scss";

class PaymentApp extends Component {
  constructor(props) {
    super(props);
    const params = queryString.parse(window.location.search);
    this.state = {
      selectedPaymentMethodGroupId: 0,
      isShowAlert: false,
      isShowPaymentConfirm: false,
      params,
      email: "",
      errorEmail: ""
    };
  }

  selectPaymentMethodGroup = group => {
    this.props.resetPaymentMethod();
    if (
      group.methodId !== this.state.selectedPaymentMethodGroupId &&
      group.paymentTypes.length === 1
    ) {
      this.onSelectedMethod(group.paymentTypes[0], group.methodId);
    }
    this.setState({
      selectedPaymentMethodGroupId:
        group.methodId !== this.state.selectedPaymentMethodGroupId
          ? group.methodId
          : 0
    });
  };

  onCheckBerforePayment = () => {
    const { selectedMethod } = this.props;
    const { email } = this.state;
    if (email && !isEmail(email)) {
      this.setState({
        errorEmail: "Vui lòng nhập đúng định dạng email"
      });
      return "";
    }
    if (selectedMethod.code) {
      this.toggleShowPaymentConfirm();
    } else {
      this.toggleAlert();
    }
  };

  toggleAlert = () => {
    this.setState({
      isShowAlert: !this.state.isShowAlert
    });
  };

  toggleShowPaymentConfirm = () => {
    this.setState(state => ({
      isShowPaymentConfirm: !state.isShowPaymentConfirm
    }));
  };

  onSelectedMethod = (method, methodId) => {
    this.props.selectedPaymentMethod(method, methodId);
  };

  handleDoPayment = () => {
    this.props.createDepositApp({
      token: this.state.params.token,
      subTotal: this.state.params.amount,
      email: this.state.email
    });
    this.setState(state => ({
      isShowPaymentConfirm: false
    }));
  };

  renderModalConfirmPayment = () => {
    const { isShowPaymentConfirm } = this.state;
    return (
      <Modal
        iconTitle={<i className="fal fa-bell" />}
        modal={isShowPaymentConfirm}
        title="Xác nhận thanh toán"
        children={this.renderBodyModalConfirmPayment()}
        centered
        footer
        footerConfirm
        className="centered"
        toggle={this.toggleShowPaymentConfirm}
        cancelText="Quay lại"
        okText="Đồng ý"
        onCancel={this.toggleShowPaymentConfirm}
        onOk={this.handleDoPayment}
      />
    );
  };

  renderModalMissMethod = () => {
    const { isShowAlert } = this.state;
    return (
      <Alert
        isModal={isShowAlert}
        message="Vui lòng chọn phương thức thanh toán"
        toggleAlert={this.toggleAlert}
      />
    );
  };

  renderBodyModalConfirmPayment = () => {
    const { selectedMethod } = this.props;
    const selectedMethodName =
      Object.keys(selectedMethod).length > 0
        ? selectedMethod.name
        : "Chọn phương thức thanh toán";

    const selectedMethodImage = get(selectedMethod, "paymentIcon.path", "");

    if (selectedMethod.bankAccount) {
      const accountHolder = get(
        selectedMethod,
        "bankAccount.accountHolder",
        ""
      );
      const accountNumber = get(
        selectedMethod,
        "bankAccount.accountNumber",
        ""
      );
      const bankBranch = get(selectedMethod, "bankAccount.bankBranch", "");
      return (
        <>
          <div className={styles.body_modal}>
            {selectedMethodImage && (
              <img
                className={styles.body_modal_image}
                src={selectedMethodImage}
                alt={selectedMethodName}
              />
            )}
            <MDBAlert color="primary">
              <p>Thông tin chuyển khoản:</p>
              Tài khoản: <strong>{accountHolder}</strong> <br />
              Số tài khoản: <strong>{accountNumber}</strong> <br />
              Chi nhánh: <strong>{bankBranch}</strong> <br />
              Số tiền:{" "}
              <strong>
                {Number(this.state.params.amount).toLocaleString("vi-VN")}đ
              </strong>
            </MDBAlert>
          </div>
        </>
      );
    }

    return (
      <>
        <div className={styles.body_modal}>
          {selectedMethodImage && (
            <img
              className={styles.body_modal_image}
              src={selectedMethodImage}
              alt={selectedMethodName}
            />
          )}
          <p>
            Thanh toán số tiền{" "}
            <strong>
              {Number(this.state.params.amount).toLocaleString("vi-VN")}đ
            </strong>{" "}
            bằng {selectedMethodName}
          </p>
          <MDBAlert color="primary">
            Bạn sẽ nhận được thông tin hóa đơn sau khi{" "}
            <strong>thanh toán thành công</strong>. Trường hợp không nhận được
            vui lòng liên hệ <strong>19002115</strong>.
          </MDBAlert>
        </div>
      </>
    );
  };

  onChangeEmail = e => {
    const value = e.target.value;
    this.setState({
      email: value,
      errorEmail: ""
    });
  };

  componentDidMount() {
    this.props.resetPaymentMethod();
    this.props.getAllPaymentMethod(10000);
  }

  render() {
    const { errorEmail } = this.state;
    const { data, selectedMethod } = this.props;

    const objCheckNextStep = Object.create(null);
    if (Object.keys(selectedMethod).length > 1) {
      objCheckNextStep.nextStep = true;
    }

    return (
      <div className={styles.wapper_page_desktop}>
        <MetaTags>
          <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
        </MetaTags>
        <MDBCard className={cx(styles.panels, styles.panel_mobile)}>
          <MDBCardHeader className={styles.panels_header}>
            <div>Chọn phương thức thanh toán</div>
          </MDBCardHeader>
          <MDBCardBody className={styles.card_body}>
            <MDBRow>
              <MDBCol md="12">
                <div className={styles.group_payment}>
                  <ListPaymentMethod
                    allPaymentMethodGroups={data}
                    handleSelectedMethod={this.onSelectedMethod}
                    selectedMethod={selectedMethod}
                    selectPaymentMethodGroup={this.selectPaymentMethodGroup}
                    selectedPaymentMethodGroupId={
                      this.state.selectedPaymentMethodGroupId
                    }
                  />
                </div>
                <div className={styles.form_group}>
                  <input
                    type="email"
                    placeholder="Nhập email để nhận thông tin hóa đơn"
                    value={this.state.email}
                    onChange={this.onChangeEmail}
                  />
                </div>
                {errorEmail && (
                  <span className={styles.error_red}>{errorEmail}</span>
                )}
              </MDBCol>
            </MDBRow>
            <div className={styles.next_prev}>
              <PKHBtn
                create="create"
                buttonArrow="buttonArrow"
                {...objCheckNextStep}
                onClick={this.onCheckBerforePayment}
              >
                Thanh toán
              </PKHBtn>
            </div>
            {this.renderModalConfirmPayment()}
            {this.renderModalMissMethod()}
          </MDBCardBody>
        </MDBCard>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const {
    payment: { selectedMethod, data, showModal, price }
  } = state;
  return {
    selectedMethod,
    data,
    showModal,
    price
  };
};

export default connect(mapStateToProps, {
  getAllPaymentMethod,
  selectedPaymentMethod,
  resetPaymentMethod,
  createDepositApp
})(PaymentApp);
